import script from "./Guided.vue?vue&type=script&setup=true&lang=js"
export * from "./Guided.vue?vue&type=script&setup=true&lang=js"

import "./Guided.vue?vue&type=style&index=0&id=8da2cae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8da2cae6"]])

export default __exports__